import { render, staticRenderFns } from "./SosKeywordCompare.vue?vue&type=template&id=63854e5a&scoped=true"
import script from "./SosKeywordCompare.vue?vue&type=script&lang=js"
export * from "./SosKeywordCompare.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SosKeywordCompare.vue?vue&type=style&index=1&id=63854e5a&prod&scoped=true&lang=css"
import style2 from "./SosKeywordCompare.vue?vue&type=style&index=2&id=63854e5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63854e5a",
  null
  
)

export default component.exports